import { render, staticRenderFns } from "./EndorsementDetails.vue?vue&type=template&id=66af633d&scoped=true"
import script from "./EndorsementDetails.vue?vue&type=script&lang=ts"
export * from "./EndorsementDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af633d",
  null
  
)

export default component.exports